export const formatReport = (report) => {
  const attributes = {};
  if (report.title) {
    attributes.title = report.title;
  }
  if (report.pr_comercial) {
    attributes.pr_comercial = report.pr_comercial;
  }
  if (report.pr_juridico) {
    attributes.pr_juridico = report.pr_juridico;
  }
  if (report.pr_financiero) {
    attributes.pr_financiero = report.pr_financiero;
  }
  if (report.pr_final) {
    attributes.pr_valoracion_final = report.pr_final;
  }
  const id = report.id && report.id !== 'dummy' ? report.id : undefined;

  return {
    data: {
      type: 'node--prereport',
      attributes,
      id,
    },
  };
};

export const processReport = (data) => {
  let preReportModel = null;
  if (data) {
    preReportModel = {};
    preReportModel.id = data.id;
    preReportModel.type = data.type;
    const { attributes } = data;
    if (attributes.title) {
      preReportModel.title = attributes.title;
    }
    if (attributes.pr_comercial) {
      preReportModel.pr_comercial = attributes.pr_comercial;
    }
    if (attributes.pr_juridico) {
      preReportModel.pr_juridico = attributes.pr_juridico;
    }
    if (attributes.pr_financiero) {
      preReportModel.pr_financiero = attributes.pr_financiero;
    }
    if (attributes.pr_valoracion_final) {
      preReportModel.pr_valoracion_final = attributes.pr_valoracion_final;
    }
  }
  return preReportModel;
};



// WEBPACK FOOTER //
// ./src/features/tab-propuesta/utils.js